<template>
  <div
    v-loading="isloading"
    class="basic_searchs_results"
    :style="{
      '--theme_color': $store.state.myRender.common.theme_color,
      '--lineNumber': pc_widgets_infor.lineNumber[pc_widgets_infor.lineNumber.radio_val].value
    }"
  >
    <div class="tooptipPart module_edit_btn">
      <my_edit_btn :module="module" :title="$t('widgets_basic_article_classification_index_336')"></my_edit_btn>
      <my_edit_btn :module="module" tabName="animation" v-if="$store.state.app.view_pattern === 'pc'"
                   :title="$t('widgets_basic_article_classification_edit_330')"></my_edit_btn>
      <!-- <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn> -->
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <div class="searchHeader">
      <div class="searchLine searchs_content"
           :class="[$route.query.border, $store.state.app.view_pattern === 'mb' ? 'type_5' : $route.query.styleType]"
           @mousedown.stop>
        <div class="searchs_input_content">
          <el-input v-model="searchWords" @keyup.enter.native="saveHistory(searchWords)"
                    :placeholder="$route.query.placeholder" @focus="showSite" @blur="hideSite"></el-input>
        </div>
        <div class="searchs_btn_content" @click="saveHistory(searchWords)">
          <a
            v-if="($route.query.styleType === 'type_0' || $route.query.styleType === 'type_1') && $store.state.app.view_pattern === 'pc'">{{ getLang($t('router_default_90')) }}</a>
          <a v-else class="iconfont icon-fangdajing"></a>
        </div>
        <div class="errorWords" v-show="errorTag"><p>{{$t('widgets_basic_searchs_index_2846')}}</p></div>
        <div class="returnWords" @click="goBack" v-if="$store.state.app.language === 'zh-cn'"><a>{{$t('view_public_topbar_11')}}</a></div>
      </div>
      <div class="site_search_dropdown"
           v-if="(hot_keyWords.length > 0 || historyWords.length > 0) && $store.state.app.view_pattern === 'pc'">
        <div class="siteContent">
          <div class="hot_keyWords" v-show="hot_keyWords.length > 0 && $route.query.showHotKey === 'true'">
            <p class="lineTitle">{{$t('widgets_basic_searchs_index_2844')}}</p>
            <div class="search_content">
              <p class="search_content_words" @click="saveHistory(item.key)" v-for="(item, index) in hot_keyWords"
                 :key="index">{{ item }}</p>
            </div>
          </div>
          <div class="history_words" v-show="historyWords.length > 0 && $route.query.showhistoryWords === 'true'">
            <p class="clearHistory lineTitle" v-if="historyWords.length > 0" @click="clearHistory">{{$t('widgets_basic_searchs_index_2845')}}</p>
            <p class="lineTitle">{{$t('components_historical_record_index_2193')}}</p>
            <div class="search_content">
              <p class="search_content_words" @click="saveHistory(item)" v-for="(item, index) in historyWords"
                 :key="index">{{ item }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="resultsContent" :class="listArr.styleType">
      <div class="lableLine">
        <div class="search_tabs">
          <div class="tabWords" :class="activeTab === 'both' ? 'selected' : ''" @click="changeTab('both')">{{$t('widgets_basic_article_classification_edit_331')}}</div>
          <div class="tabWords" :class="activeTab === item.value ? 'selected' : ''" v-for="(item, index) in allTabList"
               :key="index" @click="changeTab(item.value)">
            {{ item.label }}
          </div>
        </div>
        <div class="search_result_tabs_line"></div>
      </div>
      <div class="resultsList basic_atlas_catalog">
        <div class="resultPart result_line" :class="e.value" v-for="(e, i) in tabList" :key="e.value">
          <p class="result_title" v-if="activeTab === 'both'">{{ e.label }}</p>
          <template v-for="(item, index) in resultsData">
            <div
              v-if="(activeTab === 'both' || activeTab === item._type) && item._type === e.value"
              class="result_line"
              :class="[item._type, listArr.styleType === 'type1' ? 'product_list_3' : 'product_list_0']"
              :key="index"
            >
              <div class="pagePart" v-if="item._type === 'column'">
                <div class="pageDetail">
                  <a class="pageLine" @click="toPage(item)">
                    <p class="pageName">{{ item.name }}</p>
                  </a>
                </div>
              </div>
              <one_article
                v-if="item._type !== 'album' && item._type !== 'column' && item._type !== 'product'"
                :data="item"
                :module="module"
                :hideBtn="true"
                :img-height="infor.height[infor.height.radio_val].height"
                :rol="infor.lineNumber[infor.lineNumber.radio_val].value"
                :marginTop="infor.margin[infor.margin.radio_val].marginTop"
                :marginLeft="infor.margin[infor.margin.radio_val].marginLeft"
                :img-zoom="imgZoom"
                marginModule="equal"
                :type="articleType"
                :showSet="['date']"
                :style="{
                cursor: 'pointer'
              }"
                fromTag="search"
              ></one_article>
              <one_product v-if="item._type === 'product'" :item="item" :module="module" :hideBtn="true"
                           fromTag="search"></one_product>
              <div class="albumPart otherPage" v-if="item._type === 'album' && articleType === '0'">
                <div class="detail_line">
                  <div class="content" @click="showImg(item)">
                    <span class="title titleLine">{{ item.album_name }}</span>
                    <span class="title typeLine">{{ item.relation_category.name }}</span>
                  </div>
                </div>
              </div>
              <one_img
                v-if="item._type === 'album' && articleType === '1'"
                :item="item"
                :module="module"
                :height="infor.height[infor.height.radio_val].height"
                :col="infor.lineNumber[infor.lineNumber.radio_val].value"
                :backgroundSize="infor.backgroundType"
                :paddingLeft="infor.margin[infor.margin.radio_val].marginLeft"
                :paddingTop="infor.margin[infor.margin.radio_val].marginTop"
                :all_list="imgList"
                fromTag="search"
              ></one_img>
            </div>
          </template>
        </div>

        <div class="noResult" v-if="resultsData.length === 0">
          <div class="tipsWordsPart">
            <p>{{$t('widgets_basic_searchs_results_index_2862', [ nowSearchWords ])}}</p>
            <span>{{$t('widgets_basic_searchs_results_index_2863')}}</span>
          </div>
        </div>
        <my_page_index
          v-if="pc_widgets_infor.page.radioValue"
          :page="pc_widgets_infor.page"
          :currentPage.sync="formInline.page.currentPage"
          :total="formInline.page.total"
          @change-page="changePage"
          :widgetName='$store.state.app.language !== "zh-cn" && $store.state.app.view_pattern === "mb" ? "searchResults" : ""'
        ></my_page_index>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {getSearchsResult} from '@/api/app.js';
import one_img from '@/widgets/basic_atlas_catalog/components/one_img';
import one_article from '@/widgets/basic_article_list/components/basic_article';
import one_product from '@/widgets/basic_product_display/components/one_img';
import Cookies from 'js-cookie';
import {box_shadow_style_add, getBackgroundData, getCommonStyle} from "@/base/widgets_data_compatible";


export default {
  name: 'basic_searchs_results',
  data() {
    return {
      imgList: [],
      nowSearchWords: '',
      errorTag: false,
      formInline: {
        channelName: '',
        page: {
          total: 0,
          pageSize: 20,
          currentPage: 1
        }
      },
      isloading: false,
      historyWords: Cookies.get('historyWords_wm') ? Cookies.get('historyWords_wm').split(',') : [],
      activeTab: 'both',
      searchWords: '',
      isHover: false,
      atlasList: [],
      pageList: this.$store.state.app.pages,
      allTabList: [], // 所有有数据的tab
      // tabList: [],  // 当前页有数据的tab
      resultsData: [],
      hot_keyWords: [],
      createNewTab: true
    };
  },
  components: {
    one_img,
    one_article,
    one_product
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    searchParamsList() {
      return this.$store.state.searchs_params.searchs_params_list;
    },
    pc_widgets_infor() {
      return this.module.data.pc_widgets_infor;
    },
    listArr() {
      return this.module.data.listArr;
    },
    infor() {
      return this.module.data[this.$store.state.app.view_pattern + '_widgets_infor'];
    },
    imgZoom() {
      return this.infor.backgroundType.radio_val !== 'default' ? this.infor.backgroundType.custom.backgroundSize : this.infor.backgroundType.default.backgroundSize;
    },
    articleType() {
      return this.listArr.styleType === 'type1' ? '0' : '1';
    },
    tabList() {
      let tabList
      if (this.activeTab === 'both') {
        tabList = this.allTabList
      } else {
        tabList = this.allTabList.filter(item => {
          return item.value === this.activeTab
        })
      }
      return tabList.filter(item => {
        return this.resultsData.some(d => {
          return d._type === item.value
        })
      })
    }
  },
  watch: {
    'pc_widgets_infor.page': {
      handler(val, oldVal) {
        this.saveHistory(this.searchWords);
      },
      deep: true
    },
    '$store.state.app.language': {
      handler(val, oldVal) {
        if (val !== "zh-cn") {
          this.pc_widgets_infor.page.pageStyle = 0
        }
      },
      deep: true
    },
  },
  methods: {
    showImg(item) {
      this.$store.commit('atlas_look/SET_is_Show', true);
      this.$store.commit('atlas_look/SET_now_item', item);
      this.$store.commit('atlas_look/SET_all_list', this.imgList);
    },
    goBack() {
      this.$router.go(-1);
    },
    changePage(page) {
      this.formInline.page.currentPage = page;
      this.saveHistory(this.searchWords, page);
    },
    hideSite() {
      $('#u' + this.module.widgets_id)
        .find('.site_search_dropdown')
        .css('height', 0);
    },
    showSite() {
      if (this.$store.state.app.view_pattern === 'pc') {
        $('#u' + this.module.widgets_id)
          .find('.site_search_dropdown')
          .animate({height: 'auto'}, 200)
          .css('height', 'auto');
      }
    },
    clearHistory() {
      this.historyWords = [];
      Cookies.set('historyWords_wm', '');
    },
    toPage(item) {
      // if (this.$route.path === '/' + item.theme_name) {
      //   return false;
      // }
      let that = this;
      if (this.$store.state.app.is_change) {
        this.$confirm(i18n.t('widgets_basic_article_info_index_360'), i18n.t('view_public_topbar_23'), {
          confirmButtonText: i18n.t('widgets_basic_article_info_index_361'),
          cancelButtonText: i18n.t('view_public_topbar_11'),
          center: true,
          // customClass: 'del_dialog',
          appendToBody: true
        })
          .then(() => {
            if (item.module === 'product' || item.module === 'case' || item.module === 'help' || item.module === 'article') {
              let routeUrl = this.$router.resolve({
                path: item.theme_name,
                query: {typeId: item.tid, name: item.name}
              });
              window.open(routeUrl.href, '_blank');
            } else if (item.theme_name === 'anchor') {
              return false
            } else if (!item.module) {
              //链接
              window.open(item._link, '_blank');
            } else {
              let routeUrl = this.$router.resolve({
                path: item.theme_name
              });
              window.open(routeUrl.href, '_blank');
            }
          })
          .catch(() => {
          });
      } else {
        if (item.module === 'product' || item.module === 'case' || item.module === 'help' || item.module === 'article') {
          let routeUrl = this.$router.resolve({
            path: item.theme_name,
            query: {typeId: item.tid, name: item.name}
          });
          window.open(routeUrl.href, '_blank');
        } else if (item.theme_name === 'anchor') {
          return false
        } else if (!item.module) {
          //链接
          window.open(item._link, '_blank');
        } else {
          let routeUrl = this.$router.resolve({
            path: item.theme_name
          });
          window.open(routeUrl.href, '_blank');
        }
      }
    },
    saveHistory(searchWords, page = 1) {
      this.searchWords = searchWords;
      if (!searchWords) {
        this.errorTag = true;
        return false;
      }
      let historyWords = this.historyWords;
      if (historyWords.indexOf(searchWords) === -1) {
        if (historyWords.length >= 5) {
          historyWords.length = 4;
        }
        historyWords.splice(0, 0, searchWords);
      }
      historyWords = historyWords.join(',');
      Cookies.set('historyWords_wm', historyWords);
      this.searchFn(searchWords, page);
    },
    searchFn(searchWords, page = 1) {
      this.searchWords = searchWords;
      this.nowSearchWords = searchWords;
      if (!searchWords) {
        this.errorTag = true;
        return false;
      }
      this.isloading = true;
      let query = this.$route.query;
      let data = {
        // type: this.$route.query.searchParam.join(','),
        page: page,
        rows: this.pc_widgets_infor.page.radioValue ? parseInt(this.pc_widgets_infor.page.pageSize) : 999,
        keyword: searchWords,
        exact: query.searchType === 'accurate' ? 1 : 0
      };
      if (query.searchParams.length != 0) {
        data.type = query.searchParams.join(',');
      } else {
        let list = [];
        for (let item in this.$store.state.searchs_params.searchs_params_list) {
          list.push(item);
        }
        data.type = list.join(',');
      }
      if (this.activeTab !== 'both') {
        data.type = this.activeTab;
        this.createNewTab = false;
      } else {
        this.createNewTab = true;
      }
      getSearchsResult(data)
        .then(res => {
          if (res.code === 200) {
            this.hideSite();
            this.errorTag = false;
            this.formInline.page.total = res.data.total;
            let imgList = [];
            let resultsData = res.data.rows.map(e => {
              if (!e.name) {
                e.name = e.title;
              }
              e.imgSrc = e.img;
              e.content = e.summary;
              if (e._type === 'album') {
                imgList.push(e);
              }
              e.date = this.$moment(e.createtime * 1000).format('YYYY-MM-DD');
              return e;
            });
            this.imgList = imgList;
            if (this.pc_widgets_infor.page.pageStyle === 2) {
              if (this.resultsData.length > 0 && page == 1) {
                this.resultsData = [];
              }
              this.resultsData = this.resultsData.concat(resultsData);
            } else {
              this.resultsData = resultsData;
            }
            if (this.activeTab === 'both') {
              this.allTabList = res.data.tabs
            }
          } else {
            this.$message.warning({
              showClose: true,
              message: res.message
            });
          }
        })
        .finally(() => {
          this.isloading = false;
        });
    },
    changeTab(selectedTab) {
      this.formInline.page.currentPage = 1
      if (!this.searchWords) {
        this.errorTag = true;
        return false;
      }
      this.activeTab = selectedTab;
      this.saveHistory(this.searchWords, 1);
    },
    module_isHover(val) {
      this.isHover = val;
    },
    fixField(){
      if (!this.pc_widgets_infor.background) {
        this.$set(this.pc_widgets_infor, "background", getBackgroundData().background);
      }
      // 4.6.7 组合阴影
      if (typeof this.pc_widgets_infor.boxShadow == "undefined") {
        this.$set(this.pc_widgets_infor, "boxShadow", box_shadow_style_add().boxShadow);
      }
      if (typeof this.pc_widgets_infor.borderRadius == "undefined") {
        this.$set(this.pc_widgets_infor, "borderRadius", getCommonStyle().borderRadius);
      }
    }
  },
  mounted() {
    this.fixField()
    this.searchWords = this.$route.query.searchWords;
    if (this.searchWords) {
      this.searchFn(this.searchWords);
    }
    this.hot_keyWords = this.$route.query.hot_keyWords ? this.$route.query.hot_keyWords.split(',') : [];
    this.formInline.page.pageSize = this.pc_widgets_infor.page.pageSize;
  }
};
</script>

<style lang="scss" scoped>
.basic_searchs_results {
  position: relative;

  .tooptipPart {
    display: block;
    z-index: 999;
  }
}

.searchLine {
  width: 500px;
  height: 40px;
  margin: 40px 0;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}

.resultsContent {
  width: 100%;

  .lableLine {
    width: 100%;
  }

  .search_result_tabs_line {
    width: 100%;
    height: 1px;
    border-bottom: 1px solid #f0f0f0;
  }

  .search_tabs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    padding-left: 10px;

    .tabWords {
      -webkit-box-flex: 1;
      -ms-flex: 1 1;
      flex: 1 1;
      max-width: 95px;
      height: 40px;
      text-align: center;
      margin-right: 16px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
    }

    .tabWords.selected {
      border-color: var(--theme_color);
      color: var(--theme_color);
      font-weight: 700;
      border-bottom-style: solid;
      border-bottom-width: 2px;
      margin-bottom: -2px;
    }
  }

  .resultsList {
    .result_line {
      position: relative;
      transition: all 0.4s ease-out;
      box-sizing: border-box;

      .result_title {
        color: var(--theme_color);
        font-weight: 700;
        font-size: 15px;
        margin: 23px 0 23px 12px;
      }

      .detail_line {
        padding: 30px 10px;
        width: 100%;
        height: 100%;

        a {
          display: block;
          height: 100%;
          width: 100%;

          .title {
            display: block;
            font-size: 16px;
          }

          .titleLine {
            color: #ef4136;
          }

          .summaryLine {
            margin-top: 18px;
            color: #666;
          }
        }
      }

      .detail_line:hover {
        -webkit-box-shadow: rgba(0, 0, 0, 0.12) 0 0 22px;
        -moz-box-shadow: rgba(0, 0, 0, 0.12) 0 0 22px;
        box-shadow: rgba(0, 0, 0, 0.12) 0 0 22px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        background: #fff;

        a {
          color: var(--theme_color);

          .titleLine {
            color: var(--theme_color);
          }
        }
      }
    }

    .result_line.product {
      .detail_line {
        padding: 0;
        text-align: left;
        border: 1px solid #f0f0f0;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        -webkit-transition: none;
        -o-transition: none;
        -moz-transition: none;
        transition: none;
        width: -webkit-calc(25% - 20px);
        width: -moz-calc(25% - 20px);
        width: calc(25% - 20px);
        -webkit-transition: all 0.5s ease-out;
        -o-transition: all 0.5s ease-out;
        -moz-transition: all 0.5s ease-out;
        transition: all 0.5s ease-out;
        display: inline-block;
        text-align: center;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        margin: 10px;
        background-color: #fff;
        vertical-align: top;
        overflow: hidden;

        a {
          position: relative;
          transition: 0.5s;
          -ms-transition: 0.5s;
          -webkit-transition: 0.5s;
          -moz-transition: 0.5s;
          -o-transition: 0.5s;
          border-color: transparent;
          z-index: 1;
          padding: 5%;
          height: 100%;
          overflow: hidden;
          color: #333;
          display: block;
          text-align: left;
        }

        a:after {
          width: 100%;
          height: 100%;
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          -moz-transform: scale(0, 1);
          -ms-transform: scale(0, 1);
          -o-transform: scale(0, 1);
          transform: scale(0, 1);
          -webkit-transform: scale(0, 1);
          -webkit-transition: -webkit-transform 0.36s ease;
          transition: -webkit-transform 0.36s ease;
          -o-transition: -o-transform 0.36s ease;
          -moz-transition: transform 0.36s ease, -moz-transform 0.36s ease;
          transition: transform 0.36s ease;
          transition: transform 0.36s ease, -webkit-transform 0.36s ease, -moz-transform 0.36s ease, -o-transform 0.36s ease;
        }

        a:before {
          width: 100%;
          height: 100%;
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
          box-sizing: border-box;
          -moz-transform: scale(0, 1);
          -ms-transform: scale(0, 1);
          -o-transform: scale(0, 1);
          transform: scale(0, 1);
          -webkit-transform: scale(0, 1);
          -webkit-transition: -webkit-transform 0.36s ease;
          transition: -webkit-transform 0.36s ease;
          -o-transition: -o-transform 0.36s ease;
          -moz-transition: transform 0.36s ease, -moz-transform 0.36s ease;
          transition: transform 0.36s ease;
          transition: transform 0.36s ease, -webkit-transform 0.36s ease, -moz-transform 0.36s ease, -o-transform 0.36s ease;
        }
      }
    }

    .result_line.product:hover {
      a {
        border-color: var(--theme_color);
        color: #000000;
        color: var(--theme_color);

        .titleLine {
          color: var(--theme_color);
        }
      }

      a:after {
        transform-origin: 0 100%;
        -ms-transform-origin: 0 100%;
        -webkit-transform-origin: 0 100%;
        -moz-transform-origin: 0 100%;
        -o-transform-origin: 0 100%;
        border-bottom: 3px;
        border-bottom-style: solid;
        border-color: inherit;
        transform: scaleX(1);
        -ms-transform: scaleX(1);
        -webkit-transform: scaleX(1);
        -moz-transform: scaleX(1);
        -o-transform: scaleX(1);
      }
    }
  }
}

.searchs_content.type_5 {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  -webkit-flex-direction: row-reverse;
  -moz-box-orient: horizontal;
  -moz-box-direction: reverse;
  -ms-flex-direction: row-reverse;
  flex-direction: row-reverse;
}

.searchs_content.type_5,
.searchs_content.type_4 {
  .searchs_btn_content {
    background-color: #fff;

    a {
      color: var(--theme_color);
    }
  }
}

.searchs_content.type_5 {
  .searchs_btn_content {
    a {
      color: #808080;
    }
  }
}

.searchs_content {
  display: flex;
  height: 40px;
  border-radius: 3px;
  background-color: #fff;
  box-sizing: border-box;
  border-style: solid;
  border-width: 2px;
  font-size: 0;
  border-color: var(--theme_color);

  .searchs_input_content {
    flex: 1;
    box-sizing: border-box;

    .el-input {
      height: 99%;
      margin-left: 1px;
    }
  }

  .searchs_input_content /deep/ .el-input__inner {
    height: 100%;
    border-radius: 0;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    border: none;
  }

  .searchs_btn_content {
    box-sizing: border-box;
    width: 50px;
    background: var(--theme_color);
    height: 100%;

    a {
      display: block;
      cursor: pointer;
      font-size: 20px;
      color: #fff;
      height: 36px;
      line-height: 36px;
      padding: 0 15px;
    }
  }
}

.searchs_content.type_5 .searchs_input_content /deep/ .el-input__inner {
  padding-left: 0;
}

.searchs_content.type_0 .searchs_btn_content a,
.searchs_content.type_1 .searchs_btn_content a {
  font-size: 15px;
  padding: 0;
  text-align: center;
}

.searchs_content.type_5,
.searchs_content.type_4 {
  border-color: #ebebeb;
}

.searchs_content.type_1,
.searchs_content.type_3 {
  border-radius: 999px;

  .searchs_input_content /deep/ .el-input__inner {
    border-top-left-radius: 999px;
    border-bottom-left-radius: 999px;
  }

  .searchs_btn_content {
    border-top-right-radius: 999px;
    border-bottom-right-radius: 999px;
  }
}

.searchs_content.type_5 {
  border-radius: 999px;

  .searchs_input_content /deep/ .el-input__inner {
    border-top-right-radius: 999px;
    border-bottom-right-radius: 999px;
  }

  .searchs_btn_content {
    border-top-left-radius: 999px;
    border-bottom-left-radius: 999px;
  }
}

.searchs_content.solidColor {
  border-width: 0;
  background-color: #f1f1f1;

  .searchs_input_content /deep/ .el-input__inner {
    background-color: #f1f1f1;
  }
}

.searchs_content.solidColor.type_5,
.searchs_content.solidColor.type_4 {
  .searchs_btn_content {
    background-color: #f1f1f1;

    a {
      color: var(--theme_color);
    }
  }
}

.searchs_content.solidColor.type_5 {
  .searchs_btn_content {
    a {
      color: #808080;
    }
  }
}

.noResult {
  width: 100%;
  height: 320px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;

  .tipsWordsPart {
    text-align: center;
    line-height: 30px;
  }

  p {
    color: #333;
    font-size: 16px;
  }

  span {
    display: block;
    color: #999;
    font-size: 14px;
  }
}

.otherPage {
  .result_title {
    font-weight: 700;
    font-size: 15px;
    margin: 23px 0 23px 12px;
    color: var(--theme_color);
  }

  .detail_line {
    width: 100%;
    padding: 10px;
    display: inline-block;

    .content {
      color: #333;
      font-size: 14px;
      height: 43px;
      border-bottom: 1px dashed #ccc;
      cursor: pointer;
    }

    .typeLine {
      float: right;
      display: inline-block;
      position: relative;
      height: 26px;
      line-height: 26px;
      max-width: 100%;
      padding: 0 8px;
      margin-top: 8px;
      margin-right: 15px;
      border-radius: 3px;
      color: #666;
      background-color: #f5f5f5;
      font-size: 12px;
      word-break: keep-all;
      overflow: hidden;
      z-index: 2;
    }

    .linkPart {
      display: block;
      height: 56px;
      line-height: 56px;
      border-bottom: 1px dashed #ccc;
      font-size: 14px;
      padding-left: 10px;
      color: #333;
      cursor: pointer;
    }

    .linkPart:hover {
      color: var(--theme_color);
    }

    .content:hover {
      color: var(--theme_color);
    }
  }
}

.resultsContent .resultsList .albumPart {
  cursor: pointer;

  .detail_line {
    padding: 0;

    &:hover {
      box-shadow: none;
    }

    .content {
      line-height: 40px;
      padding-left: 10px;
    }
  }
}

.albumLine {
  display: inline-block;
  width: calc(100% / var(--lineNumber) - 20px);

  .albumPart {
    height: 100%;
  }

  .albumImg {
    position: relative;
    padding-bottom: 100%;
    overflow: hidden;

    .albumFirstImg {
      position: absolute;
      width: 100%;
      height: 100%;
      cursor: pointer;
      transition: all 0.36s ease;
    }
  }
}

.site_search_dropdown {
  display: block;
  overflow: hidden;
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 999;
  height: 0;
  width: 500px;
  background-color: #fff;
  box-shadow: 0 0 10px 0 rgba(53, 53, 53, 0.12);
  border-radius: 4px;

  .siteContent {
    padding: 20px 17px 0;
  }

  .lineTitle {
    font-size: 13px;
    color: #999;
  }

  .clearHistory {
    float: right;
    cursor: pointer;
  }

  .search_content {
    padding: 20px 0;

    .search_content_words {
      max-width: 150px;
      display: inline-block;
      margin: 0 7px 7px 0;
      padding: 5px 10px;
      border-radius: 2px;
      background-color: #f3f3f3;
      color: #333;
      font-size: 13px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      cursor: pointer;
    }

    .search_content_words:hover {
      color: #fff;
      background-color: var(--theme_color);
    }
  }
}

.resultsList.basic_atlas_catalog {
  font-size: 0;
}

.result_line {
  display: inline;
}

.pagePart {
  cursor: pointer;
  height: 56px;
  line-height: 56px;
  border-bottom: 1px dashed #ccc;
  font-size: 14px;

  .pageDetail {
    padding-left: 10px;

    > a {
      color: #333;
    }
  }
}

.returnWords {
  display: none;
}

.mb_pattern {
  .searchLine {
    width: 85%;
    position: relative;

    .returnWords {
      width: 50px;
      position: absolute;
      right: -58px;
      top: 0;
      display: block;
      line-height: 40px;
      font-size: 14px;
      color: #666;
      cursor: pointer;

      a {
        color: #666;
      }
    }
  }

  .result_line /deep/ .list_one .tooptipPart {
    display: none;
  }

  .result_line /deep/ .list_one:hover .tooptipPart {
    display: none;
  }
}

.resultsContent .product_list_3 /deep/ .list_img_frame {
  display: none;
}

.resultsContent .result_line /deep/ .list_one:hover .tooptipPart {
  display: none;
}

.errorWords {
  position: absolute;
  left: 15px;
  bottom: -25px;
  color: #ff0000;
  font-size: 14px;
}

.searchHeader {
  position: relative;
}

.basic_searchs_results .resultsContent .product_list_3 {
  /deep/ .list_one {
    text-align: left;
    border: 1px solid #f0f0f0;
    border-radius: 2px;
    transition: none;
    padding: 0;
  }

  /deep/ .list_one_wrap {
    position: relative;
    transition: 0.5s;

    .product_name_wrap .product_name {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      display: inline-block;
      max-width: 100%;
    }
  }

  /deep/ .list_img_frame {
    display: none;
  }
}

.mb_pattern {
  .searchLine {
    background: #f3f3f3;
    margin: 40px 0 40px 10px;
  }

  .searchs_content {
    border-width: 0px;
  }

  .searchs_content .searchs_input_content /deep/ .el-input__inner {
    background: #f3f3f3;
  }

  .searchs_content .searchs_btn_content {
    background: #f3f3f3;
  }
}

.mb_pattern .basic_searchs_results .product_list_3 /deep/ .list_one {
  text-align: left;
  width: 100%;
  border: none;
  margin: 0;
  padding: 15px;
  border-bottom: 1px solid #f1f1f1;

  .list_one_wrap {
    padding: 0;
  }
}

.searchLine.searchs_content.type_3,
.searchLine.searchs_content.type_2 {
  border-color: #ebebeb;
}

.searchLine.searchs_content.type_3 {
  border-color: #ebebeb;
  border-radius: 999px;
}

.mb_pattern .basic_searchs_results .product_list_0 .list_one {
  width: calc(50% - 20px);;
}

.mb_pattern .basic_searchs_results /deep/ .g-basic-article-box[data-type="1"] .news_list_img {
  padding-top: 100%;
}
.pc_pattern .basic_searchs_results /deep/ .product_list_0 .list_one .list_one_wrap .list_content_frame .product_name_wrap .product_name{
  color: #333 !important;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_searchs_results/index.vue